/* template */
<template><div :class='("mall-operations "+(mallStyle))' data-mall-theme="normal"><div class="main-btn-box"><div :class="({ btn_grey: btnGray})" class="route-btn-box" v-if="(isRouteGoods)"><mpx-view @tap="onBtnClick(goodsInfo.isSpike)" class="btn-item left-box sigle_hight_btn" v-if="(mallData.routeFromPop || !mallData.isLogin)"><special-text :text="(routeFromPopPriceText)" :rules="(routeHightLghtRules)" class="btn-item_text" v-if="(mallData.isLogin)"></special-text><div class="btn-item_text btn_item_text_login" v-else>{{ $t('common.login') }}</div></mpx-view><template v-else><mpx-view @tap="onBtnClick" class="btn-item left-box double_normal_btn"><div class="btn-item_text btn-item_text_inline btn-item_text_inline_origin"><div class="text_inline">售价</div><div class="special-text_unit text_inline">¥</div><div class="special-text_price text_inline">{{this.price}}</div></div><div class="btn-item_subtext" v-if="(spikeDef[goodsInfo.routeType])">{{spikeDef[goodsInfo.routeType].originBtnSubText}}</div></mpx-view><mpx-view @tap="onBtnClick(goodsInfo.isSpike)" class="btn-item right-box hight_btn"><div class="btn-item_text btn-item_text_inline"><div class="text_inline">特价</div><div class="special-text_unit text_inline">¥</div><div class="special-text_price text_inline">{{priceText}}</div></div><div class="btn-item_subtext" v-if="(spikeDef[goodsInfo.routeType])">{{spikeDef[goodsInfo.routeType].btnSubText}}</div></mpx-view></template></div><div :class="({ 'group-pre-sale': beforeSale,  'group-sold-out': groupSoldOut,  'origin-sold-out': groupOriginPriceSoldOut })" class="group-btn-box" v-else-if="(isGroupGoods && mallData.isLogin)"><div class="btn-bubble" v-if="(groupBtnInfo.groupBubbleText && !groupSoldOut)">{{groupBtnInfo.groupBubbleText}}</div><div class="origin-price" v-if="(beforeSale)"><template v-if="(goodsInfo.isShowCountDown)"><div class="group-time-blcok"><div class="group-time-item">{{time.h}}</div><div class="group-time-unit">:</div><div class="group-time-item">{{time.m}}</div><div class="group-time-unit">:</div><div class="group-time-item">{{time.s}}</div></div><div class="group-time-suffix">{{ $t('goodsProcess.preSaleDownTimeSuffix') }}</div></template><div class="group-time-text" v-else>{{goodsInfo.showText}}</div></div><mpx-view @tap="onBtnClick(EnumGoodsDetailIsSpike.Normal)" class="origin-price" v-else><special-text :text="(groupBtnInfo.groupOriginPriceText)" :rules="(originHightLghtRules)" class="origin-price-text"/><div class="sold-out-text" v-if="(groupOriginPriceSoldOut)">{{ $t('common.soldOut') }}</div></mpx-view><mpx-view @tap="onBtnClick(goodsInfo.isSpike)" class="group-price"><special-text :text="(groupBtnInfo.groupPriceText)" :rules="(groupHightLghtRules)" class="group-price-text"/><div class="sold-out-text" v-if="(groupSoldOut)">{{ $t('common.soldOut') }}</div></mpx-view></div><mpx-view @tap="onBtnClick" :class="({animate: animate, btn_grey: btnGray, before_sale: beforeSale})" class="special-btn-box" v-else-if="(goodsInfo.buttonPic && mallData.isLogin)"><div class="btn-left"><mpx-image :src="(buttonPic)" class="btn-left-img"></mpx-image><div class="btn-left-desc" v-if="(btnLeftDesc)">{{btnLeftDesc}}</div></div><special-text :text="(priceText)" :rules="(hightLghtRules)" class="btn-right-box"></special-text><div class="btn-center-img"></div></mpx-view><mpx-view :class="({ animate: animate, btn_grey: btnGray, credit: mallData.creditInfo && mallData.creditInfo.status === 1 })" @tap="onBtnClick" class="btn-main-content" v-else><span class="btn-main-text" v-if="(!mallData.isLogin)">{{ $t('common.login') }}</span><span class="btn-main-text" v-else-if="(mallData.price === 0)">{{ $t('goodsDetail.getFree') }}</span><div class="credit-btn-box" v-else-if="(mallData.creditInfo && mallData.creditInfo.status === 1)"><mpx-view @tap.stop="creditBtnClick(0)" class="credit-buy"><div class="credit-num"><span class="unit">{{currencySymbol}}</span>{{price}}</div><div class="credit-text">直接购买</div></mpx-view><mpx-view @tap.stop="creditBtnClick(1)" class="credit-free"><div class="credit-num"><span class="unit">{{currencySymbol}}</span>{{ mallData.creditInfo.price }}</div><div class="credit-text">{{ mallData.creditInfo.buttonTxt }}</div></mpx-view></div><special-text :text="(priceText)" :rules="(hightLghtRules)" class="normal-btn-text" v-else></special-text></mpx-view><mpx-view @tap="showMore" class="show-more" v-if="(btnGray && !hideSeeMore)">{{ $t('common.seeMore') }}></mpx-view><buyer-list :buyerList="(mallData.buyerList)" class="buyer-list-box" v-if="(!isEn && mallData.buyerList)"/></div></div></template>

/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"m945f8446"}'>
@import "../../../lib/stylus/variable.styl"
@import './theme.styl'

@keyframes shining
  0%
    box-shadow 0 10rpx 10rpx 0 rgba(255, 172, 174, .5), inset 0 10rpx 20rpx 0 rgba(255, 255, 255, .25), inset 0 -15rpx 30rpx 0 rgba(210, 15, 0, .27)
  50%
    box-shadow 0 10rpx 10rpx 0 rgba(255, 172, 174, .5), inset 0 0 30rpx 0 #FFD945, inset 0 10rpx 20rpx 0 rgba(255, 255, 255 ,.25), inset 0 -15rpx 30rpx 0 rgba(210, 15, 0, .27)
  100%
    box-shadow 0 10rpx 10rpx 0 rgba(255, 172, 174, .5), inset 0 10rpx 20rpx 0 rgba(255, 255, 255, .25), inset 0 -15rpx 30rpx 0 rgba(210, 15, 0, .27)

@keyframes move-before
  0%
    left -320rpx
  100%
    left 620rpx

@keyframes move-after
  0%
    left -240rpx
  100%
    left 700rpx

.mall-operations
  position fixed
  bottom 0
  left 0
  box-sizing border-box
  width 100%
  padding 26rpx 40rpx
  padding-bottom 26rpx
  background #FFFFFF;
  box-shadow 0 -6rpx 20rpx 0 rgba(217, 208, 196, .5)
  border-radius 30rpx 30rpx 0 0
  display flex
  flex-flow row nowrap
  justify-content center
  align-items center
  z-index 2
  &.mall-operations
    height 239rpx
  &.mall-operations-sold-out
    height 269rpx
  &.group-mall-operations
    border-radius 60rpx 60rpx 0 0

.main-btn-box
  margin-top 10rpx
  width 100%
  height 100%
  display flex
  flex-direction column
  align-items center
  .btn-main-content
    width 649rpx
    height 114rpx
    background-image linear-gradient(177deg, #FF5644 0%, #FF2919 100%)
    box-shadow 0 10rpx 10rpx 0 rgba(255, 172, 174, .5), inset 0 10rpx 20rpx 0 rgba(255, 255, 255, .25), inset 0 -15rpx 30rpx 0 rgba(210, 15, 0, .27)
    border-radius: 61rpx
    flex none
    display flex
    justify-content center
    align-items center
    &.btn_grey
      background #BDBDBD
      box-shadow: none
    &.credit
      box-shadow none
      background-image none
      &.btn_grey
        background none
    .btn-main-text
      font-size 46rpx
      color #FFFFFF
      // text-shadow 0 2rpx 10rpx #EA1E0C
      flex none
    .normal-btn-text
      font-size 44rpx
      color #FFFFFF
      font-weight 600
      display flex
      justify-content center
      align-items center
  .show-more
    margin-top 20rpx
    padding-top 20rpx 40rpx
    opacity: 0.77;
    font-size: 26rpx;
    color: #2D2D2D;
    font-weight: 400;
  .buyer-list-box
    position absolute
    top -16rpx
    left 32rpx

  .group-btn-box
    position relative
    width 686rpx
    height 118rpx
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/zRAD0ILgVQl-zVlvKRlgX.png')
    background-size 100% 100%
    margin-top 16rpx
    display flex
    align-items center
    flex none
    &.group-pre-sale
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/QTKhLiUqXXHucj7Y6b_Ws.png')
      background-size 100% 100%
      .origin-price
        margin-top 4rpx
        flex-direction column
        justify-content center
        .group-time-blcok
          display flex
          align-items center
        .group-time-item
          width 38rpx
          height 38rpx
          background-color #FF5500
          border-radius 10rpx
          font-size 24rpx
          color #FFFFFF
          text-align center
          line-height 38rpx
          padding-top 3rpx
          box-sizing border-box
        .group-time-unit
          margin -4rpx 3rpx 0 3rpx
          font-family PingFangSC-Semibold
          font-size 24rpx
          font-weight 600
        .group-time-suffix
          margin-top 4rpx
          font-size 20rpx
          color #FF5E1F
          letter-spacing 0
          font-weight 500
      .group-time-text
        margin-left -21rpx
        // margin-top 7rpx
        opacity 0.8
        font-family BarlowSemiCondensed-Medium
        font-size 30rpx
        color #FF6400
        font-weight 700
        line-height 33rpx
    &.group-sold-out
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/QTKhLiUqXXHucj7Y6b_Ws.png')
      background-size 100% 100%
      .group-price
        flex-direction column
        justify-content flex-start
        .group-price-text
          margin-top -4rpx
        .sold-out-text
          margin-top -4rpx
          opacity 0.8
          font-size 24rpx
          letter-spacing 0
          font-weight 600
    &.origin-sold-out
      // background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/QTKhLiUqXXHucj7Y6b_Ws.png')
      // background-size 100% 100%
      .origin-price
        opacity 0.4
        flex-direction column
        align-items center
        justify-content center
      .origin-price-text
        margin-top 4rpx
      .sold-out-text
        margin-top 12rpx
        opacity 0.8
        font-size 24rpx
        letter-spacing 0
        font-weight 600
    .origin-price
      position absolute
      top 0
      left 0
      width 300rpx
      font-size 40rpx
      color #FF5500
      line-height 29.26rpx
      font-weight 600
      height 100%
      display flex
      align-items center
      justify-content center
    .group-price
      margin-left 224rpx
      flex 1
      font-size 40rpx
      color #FFFFFF
      font-weight 600
      height 100%
      display flex
      align-items center
      justify-content center
      .group-price-text
        margin-top -10rpx
    .btn-bubble
      position absolute
      top -30rpx
      right 0
      min-width 143rpx
      height 57rpx
      padding 0 24rpx
      box-sizing border-box
      background-image linear-gradient(267deg, #FFEB18 14%, #FEFFBE 100%)
      border-radius 100rpx 100rpx 100rpx 0
      text-align center
      line-height 57rpx
      font-size 22rpx
      color rgba(0, 0, 0, 0.64)
      font-weight 600

  .credit-btn-box
    width 670rpx
    display flex
    background-color #ffffff
    .credit-buy,.credit-free
      width 323rpx
      height 100rpx
      background-color rgba(255,86,68,0.1)
      border-radius 61rpx
      padding-bottom 9rpx
      color #FF4231
      display flex
      flex-direction column
      align-items center
      justify-content center
      .credit-num
        line-height 51rpx
        font-size 44rpx
        .unit
          line-height 28rpx
          font-size 24rpx
      .credit-text
        line-height 28rpx
        font-size 24rpx
    .credit-free
      background-color rgba(255,86,68,1)
      margin-left 24rpx
      color #ffffff

  .special-btn-box
    position relative
    margin-top 14rpx
    width 689rpx
    height 122rpx
    background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/KWoW4o4PPT_Chej06_Aes.png')
    background-size 100% 100%
    display flex
    align-items center
    flex none
    &.btn_grey
      .btn-right-box
        position absolute
        top -1rpx
        right -2rpx
        height 124rpx
        background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/66a5SWU4YAujiEWfNkSjF.png')
        background-size 100% 100%
      .btn-center-img
        background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/Nvv3dsNnCbgrY_IyAC1h1.png')
        background-size 100% 100%
    &.before_sale
      .btn-right-box
        background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/OQvbR6Lq-RwxmrxEhBxe2.png')
        background-size 100% 100%
    .btn-left
      margin-left 58rpx
      height 100%
      width 280rpx
      display flex
      flex-direction column
      align-items flex-start
      justify-content center
    .btn-left-img
      min-width 142rpx
      max-width 154rpx
      height 39rpx
    .btn-left-desc
      margin-top 7rpx
      opacity 0.8
      font-family BarlowSemiCondensed-Medium
      font-size 24rpx
      color #FF6400
      font-weight 700
      line-height 33rpx
    .btn-center-img
      position absolute
      right 374rpx
      top -6rpx
      width 88rpx
      height 131rpx
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/1DUbAeAiVazIwH0zJDsaq.png')
      background-size 100% 100%
    .btn-right-box
      position absolute
      right 0
      top 0
      width 443rpx
      height 122rpx
      background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/FJBVM5vgbhXkLvlRCpeHu.png')
      background-size 100% 100%
      font-size 44rpx
      color #FFFFFF
      font-weight 600
      display flex
      align-items center
      justify-content center

  .route-btn-box
    display flex
    justify-content center
    .btn-item
      width: 323rpx;
      height: 109rpx;
      border-radius: 61rpx;
      display flex
      flex-direction column
      justify-content center
      align-items center
      margin-right 14rpx
      &:last-of-type
        margin-right 0
      &.double_normal_btn
        color: #FF4231;
        background: #FFEDEB;
        border: 2rpx solid rgba(255,66,49,1);
      &.hight_btn
        background-image: linear-gradient(180deg, #FF8936 9%, #F71F31 74%, #FB4B62 100%), linear-gradient(177deg, #FF5644 0%, #FF2919 100%);
        box-shadow: inset 0px 10px 20px 0px rgba(255,255,255,0.25);box-shadow: inset 0px -15px 30px 0px rgba(210,15,0,0.27);box-shadow: 0px 10px 10px 0px rgba(255,172,174,0.5);
        .btn-item_text
          font-size: 29.53rpx
          font-family: PingFangSC-Semibold;
          color: #FFFFFF;
          text-align: center;
          font-weight: 400;
        .btn-item_subtext
          color: rgba(255,255,255 .6)
          font-weight: 600;
      &.sigle_hight_btn
        width: 650rpx;
        height: 114rpx;
        background-image: linear-gradient(180deg, #FF8936 9%, #F71F31 74%, #FB4B62 100%);
        border-radius: 100rpx;
        .btn-item_text
          height: 62rpx;
          font-family: PingFangSC-Semibold;
          font-size: 44rpx;
          color: #FFFFFF;
          text-align: center;
          font-weight: 600;
          margin-top: 8rpx
          &.btn_item_text_login
            line-height 114rpx
            height 114rpx
            marign-top 0
    .btn-item_text
      font-family: PingFangSC-Medium;
      font-size: 26rpx;
      text-align: right;
      line-height: 28rpx;
      font-weight: 500;
      &.btn-item_text_inline
        .text_inline
          display inline
        .special-text_unit
          padding 0 3rpx
          display inline
          font-weight: 700;
        .special-text_price
          display inline
          font-family: Barlow-ExtraBoldItalic;
          font-size: 59.05rpx;
          font-weight: 400;
        &.btn-item_text_inline_origin
          .special-text_unit
            padding-left 7rpx
          .special-text_price
            font-family: Barlow-Medium,PingFangSC-Medium;
            font-size: 44rpx;
            font-weight: 500;

    .btn-item_subtext
      font-family: PingFangSC-Regular;
      font-size: 22rpx;
      line-height: 28rpx;
      font-weight: 400;
      color: rgba(244,35,1, .6)
      margin-top: 8rpx
    &.btn_grey
      .btn-item
        background #BDBDBD
        box-shadow: none
        &.double_normal_btn
          color: #FFFFFF;
          border: none
        .btn-item_subtext
          color: #ffffff !important

.animate
  overflow hidden
  position relative
  animation shining 2040ms cubic-bezier(0.66, 0, 0.34, 1) infinite 360ms
  border-radius: 61rpx
  &:before
    position absolute
    top -54rpx
    content ''
    display block
    width 220rpx
    height 216rpx
    transform rotate(21deg)
    background-image linear-gradient(270deg, rgba(252, 255, 174, .49) 17%, rgba(253, 255, 144, .1) 59%, rgba(253, 255, 140, 0) 87%)
    z-index 3
    animation move-before 2040ms cubic-bezier(0.66, 0, 0.34, 1) infinite 360ms
  &:after
    position absolute
    top -54rpx
    left 80rpx
    content ''
    display block
    width 220rpx
    height 216rpx
    transform rotate(21deg)
    background-image linear-gradient(226deg, rgba(252, 255, 174, .49) 8%, rgba(253, 255, 144, .1) 45%, rgba(253, 255, 140, 0) 71%)
    z-index 2
    animation move-after 2040ms cubic-bezier(0.66, 0, 0.34, 1) infinite 360ms
  .btn-main-text
    position relative
    z-index 4
theme()

@css {
  @supports (padding-bottom: constant(safe-area-inset-bottom)) {
    .mall-operations {
      padding-bottom: calc(constant(safe-area-inset-bottom) + 26rpx);
    }
    @supports (padding: max(0px)) {
      .mall-operations {
        padding-bottom: max(constant(safe-area-inset-bottom), 26rpx);
      }
    }
  }
  @supports (padding-bottom: env(safe-area-inset-bottom)) {
    .mall-operations {
      padding-bottom: calc(env(safe-area-inset-bottom) + 26rpx);
    }
    @supports (padding: max(0px)) {
      .mall-operations {
        padding-bottom: max(env(safe-area-inset-bottom), 26rpx);
      }
    }
  }
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { ComponentsMixin } from '../../../lib/webx/mpx/mixins/page_detail/component'
import { formatFen2Yuan, rpx } from '../../../lib/webx/utils/format'
import { is, utils } from '@didi/webx-js'
import { navigateTo } from '../../../lib/webx/utils/ui'
import { GlobalEnv } from '../../../lib/webx/global_env'
import { TransferStation } from '../../../lib/webx/utils/transfer_station'
import { mallTrackStd } from '../../../lib/webx/common_methods/track'
import { EnumGoodsDetailIsSpike, EnumLang, EnumRouteType } from '../../../lib/webx/defines'
import { isDyProgramH5 } from '@/lib/js/env'
import { syncServerTimeSpikePolling } from '../../../lib/webx'
import { getCurrencyText, getCurrencySymbols } from '../../../lib/js/util'
import { getProdConfFromApollo } from '../../../lib/webx/global_env/get_prod_config'

const GoodsSpike = {
  [EnumGoodsDetailIsSpike.Route]: {
    [EnumRouteType.Start]: {
      btnSubText: '固定起点',
      originBtnSubText: '不限起点',
    },
    [EnumRouteType.End]: {
      btnSubText: '固定目的地',
      originBtnSubText: '不限目的地',
    },
    [EnumRouteType.Both]: {
      btnSubText: '固定路线',
      originBtnSubText: '不限路线',
    },
  },
  default: {},
}

createComponent({
  mixins: [ ComponentsMixin ],
  data: {
    routeHightLghtRules: {
      '{x}': {
        style: Object.entries({
          position: 'relative',
          top: rpx('2rpx'),
          'color': '#FFFFFF',
          'font-family': 'Barlow-ExtraBoldItalic',
          'font-size': rpx('68rpx'),
          'font-weight': 400,
        }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
      },
    },
    hightLghtRules: {
      '{x}': {
        style: Object.entries({
          position: 'relative',
          top: rpx('-8rpx'),
          'color': '#FFFFFF',
          'font-family': 'Barlow-ExtraBoldItalic',
          'font-size': rpx('68rpx'),
          'font-weight': 400,
        }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
      },
    },
    originHightLghtRules: {
      '{x}': {
        style: Object.entries({
          position: 'relative',
          top: rpx('2rpx'),
          'font-family': 'Barlow-Medium',
          'font-size': rpx('48rpx'),
          'font-weight': 'normal',
        }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
      },
    },
    btnDesc: '',
    countDown: 0,
    nowTime: 0,
    timer: null,
    spikeDef: {},
    EnumGoodsDetailIsSpike,
  },
  computed: {
    groupHightLghtRules() {
      return {
        '{x}': {
          style: Object.entries({
            position: 'relative',
            top: rpx('4rpx'),
            'margin-right': rpx('4rpx'),
            'font-family': 'Barlow-ExtraBoldItalic',
            'font-size': (this.groupSoldOut || this.btnGray) ? rpx('66rpx') : rpx('70rpx'),
            'font-weight': 'normal',
          }).map(([ key, value ]) => `${key}: ${value}`).join(';'),
        },
      }
    },
    isRouteGoods() {
      return !!(this.goodsInfo.isSpike === EnumGoodsDetailIsSpike.Route && this.mallData.routeType)
    },
    isGroupGoods() {
      return this.goodsInfo.isSpike === EnumGoodsDetailIsSpike.Group
    },
    // 商品信息
    goodsInfo() {
      return this.mallData.goods || {}
    },
    beforeSale() {
      return this.mallData.showText && !this.mallData.isSoldOut && this.nowTime < this.goodsInfo.startTime
    },
    btnGray() {
      return this.mallData.isSoldOut || this.nowTime > this.goodsInfo.endTime
    },
    // 拼团价购买时售罄
    groupSoldOut() {
      return this.isGroupGoods && (!this.goodsInfo.groupBalanceLeft || this.nowTime > this.goodsInfo.endTime)
    },
    // 拼团原价售罄
    groupOriginPriceSoldOut() {
      return this.isGroupGoods && (!this.goodsInfo.singleBalanceLeft || this.nowTime > this.goodsInfo.endTime)
    },
    // 隐藏查看更多套餐
    hideSeeMore() {
      return getProdConfFromApollo(this.goodsInfo.productType, { searchKey: 'goods_detail.hide_see_more_btn' })
    },
    // 动画
    animate() {
      return !is('miniprogram') && this.mallData?.creditInfo?.status !== 1 && !this.btnGray && !this.beforeSale
    },
    // 购买价格，取接口show_cash字段
    price() {
      console.log(this.groupSoldOut)
      return formatFen2Yuan(this.mallData.price)
    },
    currencySymbol() {
      return getCurrencySymbols(this.mallData.currency)
    },
    // 单位
    currencyText() {
      return getCurrencyText(this.mallData.currency)
    },
    originPriceText() {
      return `原价 ¥{${this.price}}`
    },
    routeFromPopPriceText() {
      return `确认并支付{${formatFen2Yuan(this.mallData.routePrice)}}元`
    },
    // 按钮价格文案
    priceText() {
      if (this.isRouteGoods) {
        return formatFen2Yuan(this.mallData.routePrice)
      }
      return this.goodsInfo.buttonPic ? this.$t('goodsDetail.btnBuyText', { price: `{${this.price}}${this.currencyText}` }) :  this.$t('goodsDetail.buyFor', { price: `{${this.price}}${this.currencyText}` })
    },
    // 按钮模块样式
    mallStyle() {
      if (this.goodsInfo.isSpike === EnumGoodsDetailIsSpike.Group) return 'group-mall-operations'
      return this.mallData.isSoldOut ? 'mall-operations-sold-out' : 'mall-operations'
    },
    isEn() {
      return GlobalEnv.lang === EnumLang['en-US']
    },
    // 当按钮为特殊样式时左边图片
    buttonPic() {
      const pic = this.goodsInfo.buttonPic
      return utils.webpUrl(pic)
    },
    // 拼团按钮信息
    groupBtnInfo() {
      const xpExtra = this.goodsInfo.xpExtra || {}
      const people = xpExtra.shouldPeopleNum - 1 // 需要邀请的人数，总人数-1
      return {
        groupOriginPriceText: this.$t('goodsDetail.originalPriceText', { price: `{${this.price}}${this.currencyText}` }), // 拼团原价文案
        groupPriceText: this.$t('goodsDetail.groupPriceText', { price: `{${formatFen2Yuan(this.goodsInfo.groupPrice)}}${this.currencyText}` }), // 拼团价购买文案
        groupBubbleText: people ? this.$t('goodsDetail.invitePeople', { nums: people }) : '', // 按钮气泡文案
      }
    },
    // 售卖中倒计时
    time() {
      const hour = 3600
      const day = this.countDown / hour / 24
      if (day >= 1) {
        return {
          day: Math.ceil(day),
        }
      }
      const h = Math.floor(this.countDown / hour)
      const hourS = hour * h
      const m = Math.floor((this.countDown - hourS) / 60)
      const s = Math.floor((this.countDown - hourS) % 60)
      function timeFormat(time) {
        return String(time).padStart(2, '0')
      }
      return {
        h: timeFormat(h),
        m: timeFormat(m),
        s: timeFormat(s),
      }
    },
    // 特殊样式时左下方文案
    btnLeftDesc() {
      if (this.goodsInfo.isShowCountDown) {
        const prefix = this.mallData.showText ?  '' : this.$t('common.countdown')
        const suffix = this.mallData.showText ?  this.mallData.showText : ''
        if (this.time.day) {
          return prefix + this.time.day + this.$t('common.day') + suffix
        }
        return prefix + this.time.h + ':' + this.time.m + ':' + this.time.s + suffix
      }
      return this.goodsInfo.showText
    },
  },
  attached() {
    this.spikeDef = GoodsSpike[this.goodsInfo.isSpike] || {}
    this.nowTime = this.goodsInfo.currentTime
    // 需要展示倒计时时的初始时间差
    if (this.goodsInfo.isShowCountDown) {
      this.countDown = this.mallData.showText ?  this.goodsInfo.startTime - this.goodsInfo.currentTime : this.goodsInfo.endTime - this.goodsInfo.currentTime
    }
    // 秒杀商品需要轮询时间接口
    if ([ EnumGoodsDetailIsSpike.LimitCount, EnumGoodsDetailIsSpike.LimitTime ].includes(this.goodsInfo.isSpike)) {
      this.init()
    } else {
      this.goodsInfo.isShowCountDown && this.handleTime()
    }
  },
  detached() {
    this.timer && clearTimeout(this.timer)
  },
  methods: {
    init() {
      syncServerTimeSpikePolling(1000 * 30, time => {
        clearTimeout(this.timer)
        this.nowTime = time / 1000
        this.handleTime()
      }, () => {
        this.nowTime = new Date().getTime() / 1000
        const time = this.getCountDown()
        this.countDown = parseInt(time)
        this.handleTime()
      })
    },
    getCountDown() {
      const endTime = this.mallData.showText ? this.goodsInfo.startTime : this.goodsInfo.endTime // 单位是秒
      const now = this.nowTime
      const time = endTime - now
      return time
    },
    handleTime() {
      this.timer = setTimeout(() => {
        const time = this.getCountDown()
        if (time > 0) {
          // 还没开始
          this.countDown = parseInt(time)
          this.handleTime()
        } else {
          this.countDown = 0
          // 已经开售，调用更新状态接口
          this.callMall('refreshDetailInfo')
        }
        this.nowTime = this.nowTime + 1
      }, 1000)
    },
    /** orderBySpike 以商品spike的方式下单 */
    onBtnClick(orderBySpike) {
      console.log('onBtnClick==onBtnClick', orderBySpike, this.mallData.isLogin, this.mallData.isSoldOut, this.mallData.showText)
      orderBySpike = typeof orderBySpike === 'number' ? orderBySpike : null
      if (!this.mallData.isLogin) {
        mallTrackStd('userteam_details_log_btn_ck', '商详页登录按钮点击', {
          goods_id: this.goodsInfo.goodsId,
        })
        this.trackCk(3)
        this.callMall('login')
        return
      }
      // 拼团价-无库存
      if (this.isGroupGoods && orderBySpike === EnumGoodsDetailIsSpike.Group && !this.goodsInfo.groupBalanceLeft) {
        this.trackCk(1)
        return
      }
      // 拼团原价购买无库存
      if (this.isGroupGoods && orderBySpike === EnumGoodsDetailIsSpike.Normal && !this.goodsInfo.singleBalanceLeft) {
        this.trackCk(1)
        return
      }
      // 普通-无库存
      if (this.mallData.isSoldOut) {
        this.trackCk(1)
        // this.callMall('goIndex')
        return
      }
      if (this.mallData.showText) {
        this.trackCk(2)
        // 开售前
        return
      }
      const _routeInfo = TransferStation.routeInfo[Number(this.goodsInfo.goodsId)] || {}
      // 线路价
      console.log('orderBySpike==', orderBySpike, this.isRouteGoods, _routeInfo?.allowCreateOrderFlag)
      if (orderBySpike && this.isRouteGoods && !_routeInfo?.allowCreateOrderFlag ) {
        this.trackCk(4)
        this.callPageMethod('showRoutePop', _routeInfo)
        return
      }
      // 当为线路套餐时，且没有选择相应路线时，则弹出弹窗
      // 当需要确认下单时跳确认订单页面
      // 配置了apollo开关或者抖音环境下，跳转到确认订单页面
      const confirmSwitch = getProdConfFromApollo(this.goodsInfo.productType, { searchKey: 'order_confirm.confirm_switch' })
      if (confirmSwitch || isDyProgramH5()) {
        this.trackCk(0, {
          subType: 'order',
        })
        navigateTo('orderConfirm', {
          id: this.goodsInfo.goodsId,
          token: GlobalEnv.loginInfo.token,
        })
        return
      }
      const disableOrderTrack = this.isRouteGoods && !orderBySpike
      if (disableOrderTrack) {
        mallTrackStd('wyc_linepackage_homepage_ck', '商详页购买按钮点击', {
          package_id: this.goodsInfo.goodsId,
          goods_id: this.goodsInfo.goodsId,
          status,
          ck_type: 3,
          package_type: this.goodsInfo.isSpike,
          route_type: this.goodsInfo.routeType,
          page_type: 1,
        })
      }
      this.callMall('createOrder', { orderBySpike: typeof orderBySpike === 'number' ? orderBySpike : null, disableOrderTrack })
    },
    trackCk(status, attrs = {}) {
      mallTrackStd('wyc_trippackage_homepage_ck', '线路套餐详情页非按钮点击', {
        package_id: this.goodsInfo.goodsId,
        goods_id: this.goodsInfo.goodsId,
        status,
        package_type: this.goodsInfo.isSpike,
        route_type: this.goodsInfo.routeType,
        ...attrs,
      })
    },
    showMore() {
      this.callMall('goIndex')
    },
    downTimeEnd() {
      // location.reload()
    },
    creditBtnClick(param) {
      this.callMall('createOrder', {
        'source_id':param ? 'credit' : null,
        'is_free':param,
      })
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "index945f8446",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'special-text':getComponent(require("../../../../node_modules/@didi/mpx-ui/src/components/special-text/index.mpx?component=true&componentId=index8d2b07c0")),'buyer-list':getComponent(require("./buyer-list.mpx?component=true&componentId=buyer-list66698d0a")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("builtInComponent.vue!=!../../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
